<template>
  <v-container fluid>
    <h1>Why Replace Your Windows</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-img :src="image" class="image" alt="Window Image" left></v-img>
        </v-row>
        <v-row>
          <p>
            Here are the most important reasons to consider energy-efficient
            window replacement in <linkto text="Colorado Springs" to="/location/coloradosprings"></linkto> 
            and <linkto text="Denver" to="/location/denver"></linkto>.
          </p>
        </v-row>
        <v-row>
          <ol>
            <li>
              <strong> Comfort. </strong>
              Windows that include a Low-E coating reflect interior heat, which
              keeps your home warmer in the winter while still allowing light to
              pass through. The U.S. Department of Energy estimates that Low-E
              windows cost 10-15% more than a standard window, but reduce energy
              loss by 30-50%!
            </li>
            <li>
              <strong> Savings. </strong>
              Depending on your current situation, the extra cost of
              energy-efficient windows could be recovered within the first few
              years of use as a result of savings on utility bills. In addition,
              installing ENERGY STAR-rated windows before the end of 2013 makes
              you eligible for a federal tax credit of up to $500.
            </li>
            <li>
              <strong> Increased home value. </strong>
              There is clear evidence that investments in energy efficiency lead
              to higher home resale values. Homeowners can expect to recover
              70-80% of the cost of energy-efficient window replacement when
              they sell their home.
            </li>
          </ol>
        </v-row>
        <v-row>
          <h2>Call for a Quote on Replacement Windows</h2>
          <p>
            AquaDuct can assist you in choosing the right replacement windows in
            <linkto text="Colorado Springs" to="/location/coloradosprings"></linkto> 
            to meet your needs and budget. Give us a call today
            at
            <phonenumber phone="(719) 390-7663"></phonenumber> to learn more
            about the quality products we offer and to receive a FREE estimate!
          </p>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
        <!-- <guild></guild> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
// import router from '@/_router/index'
// import guild from "@/components/controls/GuildQuality";
import phonenumber from "@/components/controls/phone-number";
import linkto from "@/components/controls/link-to";

export default {
  name: "window-replace",

  components: {
    estimate,
    // guild,
    linkto,
    phonenumber,
  },

  created() {},

  data: () => ({
    image: require("@/assets/windows-3.jpg"),
  }),

  methods: {},
};
</script>

<style lang="scss" scoped>
.image {
  margin-bottom: 20px;
}
</style>
